import { render, staticRenderFns } from "./yhubReportTem.vue?vue&type=template&id=66ea247a&scoped=true"
import script from "./yhubReportTem.vue?vue&type=script&lang=js"
export * from "./yhubReportTem.vue?vue&type=script&lang=js"
import style0 from "./yhubReportTem.vue?vue&type=style&index=0&id=66ea247a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea247a",
  null
  
)

export default component.exports